import { IconAddPlus } from '@components/icons/add-plus';
import { IconForm } from '@components/icons/form';
import { IconUrl } from '@components/icons/url';
import { ListCard } from '@components/list-card';
import { Sidebar, useSidebar } from '@components/sidebar';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useAddCustomLinkSidebar } from './add-custom-link';
import { useAddJourneyFormSidebar } from './add-journey-form';

export const useAddToPortalSidebar = () => {
  const sidebar = useSidebar(AddToPortalSidebar, {
    variant: 'REGULAR',
    closeOnClickOutside: true,
  });
  return sidebar;
};

export const AddToPortalSidebar = ({ portalShortId }: { portalShortId: string }) => {
  const { t } = useScopedTranslate(locale);
  const showAddCustomLinkSidebar = useAddCustomLinkSidebar();
  const showAddJourneyFormSidebar = useAddJourneyFormSidebar();

  return (
    <Sidebar>
      <Sidebar.SimpleHeader
        icon={IconAddPlus}
        iconColor="elementBlue100"
        title={t('addToPortal')}
      />
      <Sidebar.Content>
        <Stack space={6}>
          <Text font="regular14" text={t('description')} />
          <Stack space={2}>
            <ListCard
              title={t('externalForm')}
              description={t('externalFormDescription')}
              icon={<IconForm color="elementPurple80" />}
              spaceX={4}
              spaceY={2}
              onClick={() => showAddJourneyFormSidebar({ portalShortId })}
            />
            <ListCard
              title={t('customLink')}
              description={t('customLinkDescription')}
              icon={<IconUrl color="elementPurple80" />}
              spaceX={4}
              spaceY={2}
              onClick={() => showAddCustomLinkSidebar({ portalShortId })}
            />
          </Stack>
        </Stack>
      </Sidebar.Content>
    </Sidebar>
  );
};

export const locale = {
  en: {
    addToPortal: 'Add to portal',
    description: 'Add external forms or site links to display on this portal',
    externalForm: 'External form',
    externalFormDescription: 'Select an external form from a specific journey',
    customLink: 'Custom link',
    customLinkDescription: 'Redirect user to a custom external link',
  },
};
